import $ from "jquery";

function SmoothScroll() {
  $.easing.quart = function (x, t, b, c, d) {
    return -c * ((t = t / d - 1) * t * t * t - 1) + b;
  };

  $(".js-scroll").on("click", function () {
    var speed = 1200,
      href = $(this).attr("href"),
      target = $(href == "#" || href == "" ? "html" : href),
      position = target.offset().top;

    $("html, body").animate(
      {
        scrollTop: position,
      },
      speed,
      "quart",
    );

    // return false;
  });
}

export { SmoothScroll };
